// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-06cd755d] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-settings-section[data-v-06cd755d] {
  --form-element-label-offset: calc(var(--border-radius-element) + var(--default-grid-baseline));
  --app-settings-section-text-offset: var(--form-element-label-offset);
  --app-settings-section-content-gap: calc(6 * var(--default-grid-baseline));
  margin-block-end: calc(8 * var(--default-grid-baseline));
}
.app-settings-section__name[data-v-06cd755d] {
  margin: 0;
  padding-inline: var(--app-settings-section-text-offset);
  padding-block: 0;
  font-size: 20px;
  font-weight: bold;
}
.app-settings-section__description[data-v-06cd755d] {
  padding-inline: var(--app-settings-section-text-offset);
  color: var(--color-text-maxcontrast);
}
.app-settings-section__content[data-v-06cd755d] {
  margin-block-start: calc(2 * var(--default-grid-baseline));
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  gap: var(--app-settings-section-content-gap);
}
.app-settings-section__legacy[data-v-06cd755d] {
  --app-settings-section-text-offset: 0;
  --app-settings-section-content-gap: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppSettingsSection-Yg4NYCih.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,8FAA8F;EAC9F,oEAAoE;EACpE,0EAA0E;EAC1E,wDAAwD;AAC1D;AACA;EACE,SAAS;EACT,uDAAuD;EACvD,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,uDAAuD;EACvD,oCAAoC;AACtC;AACA;EACE,0DAA0D;EAC1D,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,4CAA4C;AAC9C;AACA;EACE,qCAAqC;EACrC,qCAAqC;AACvC","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-06cd755d] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-settings-section[data-v-06cd755d] {\n  --form-element-label-offset: calc(var(--border-radius-element) + var(--default-grid-baseline));\n  --app-settings-section-text-offset: var(--form-element-label-offset);\n  --app-settings-section-content-gap: calc(6 * var(--default-grid-baseline));\n  margin-block-end: calc(8 * var(--default-grid-baseline));\n}\n.app-settings-section__name[data-v-06cd755d] {\n  margin: 0;\n  padding-inline: var(--app-settings-section-text-offset);\n  padding-block: 0;\n  font-size: 20px;\n  font-weight: bold;\n}\n.app-settings-section__description[data-v-06cd755d] {\n  padding-inline: var(--app-settings-section-text-offset);\n  color: var(--color-text-maxcontrast);\n}\n.app-settings-section__content[data-v-06cd755d] {\n  margin-block-start: calc(2 * var(--default-grid-baseline));\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  gap: var(--app-settings-section-content-gap);\n}\n.app-settings-section__legacy[data-v-06cd755d] {\n  --app-settings-section-text-offset: 0;\n  --app-settings-section-content-gap: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
